// Mobile nav toggle
function toggleMobileNav() {
  var links = document.getElementById('nav-links');
  var btn = document.getElementById('nav-hamburger');
  links.classList.toggle('mobile-open');
  btn.classList.toggle('open');
  document.body.style.overflow = links.classList.contains('mobile-open') ? 'hidden' : '';
}
function closeMobileNav() {
  document.getElementById('nav-links').classList.remove('mobile-open');
  document.getElementById('nav-hamburger').classList.remove('open');
  document.body.style.overflow = '';
}

// Radio button visual toggle
document.addEventListener('click', function(e) {
  var label = e.target.closest('.form-radio-label');
  if (label) {
    var name = label.querySelector('input').name;
    document.querySelectorAll('.form-radio-label input[name="' + name + '"]').forEach(function(input) {
      input.closest('.form-radio-label').classList.remove('selected');
    });
    label.classList.add('selected');
  }
});
